"use strict";

/**
 * This file deal with the backward compatibility of the schema between the old and the new schema.
 *
 */

const extend = require("extend");

import knownQuestionDefaults from "./_schemaElevator_knownQuestionDefaults";

const elevateOverride = function (k, value) {
    if (typeof value != "undefined" && value !== null) {
        return value;
    }
    else if (k in knownQuestionDefaults.overrides) {
        return knownQuestionDefaults.overrides[k];
    }
    else {
        return true;
    }
};

const unelevateOverride = function (k, value) {
    //Check if having null is equivalent to having value,
    // if yes, return null,
    // else value if good.
    if (elevateOverride(k, null) == value) {
        return null;
    }
    return value;
};

const elevateQuestion = function (k, value?) {
    return extend(true, {},
        {
            askPlusOnes: true
        },
        knownQuestionDefaults.customQuestions[k],
        value || {});
};


const elevateSortKey = function (k, value) {
    return [value, knownQuestionDefaults.sortKeys[k], ("m" + k)]
        .reduce((acc, curr) => (typeof acc != "undefined" && acc !== null) ? acc : curr);
};

const unelevateSortKey = function (k, value) {
    //Check if having null is equivalent to having value,
    // if yes, return null,
    // else value if good.
    if (elevateSortKey(k, null) == value) {
        return null;
    }
    return value;
};


const elevateSchema = function (data) {

    data = data || {};
    data.customQuestions = data.customQuestions || {};
    data.sortKeys = data.sortKeys || {};
    data.overrides = data.overrides || {};

    //All known questionKeys
    var questionsKeys = Object.keys(extend(true, {},
        knownQuestionDefaults.customQuestions,
        ((data || {}).customQuestions || {})
    ));

    var elevatedData = questionsKeys
        .map(k => {
            return {
                k: k,
                q: elevateQuestion(k, data.customQuestions[k]),
                s: elevateSortKey(k, data.sortKeys[k]),
                o: elevateOverride(k, data.overrides[k])
            };
        })
        .reduce((acc, curr) => {
            acc.customQuestions[curr.k] = curr.q;
            acc.overrides[curr.k] = curr.o;
            acc.sortKeys[curr.k] = curr.s;
            return acc;
        }, {
            customQuestions: {},
            sortKeys: {},
            overrides: {}
        });
    return elevatedData;
};

export default {elevateQuestion, elevateSchema, elevateSortKey, unelevateSortKey, elevateOverride, unelevateOverride};
